import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/matzeva.actions';

import LayoutContainer from 'containers/LayoutContainer';
import MatzevaShow from 'views/public/MatzevaView/components/MatzevaShow';

import Loading from 'components/commons/Loading';

import 'views/public/MatzevaView/components/MatzevaShow/i18n';

const MatzevaShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.matzeva);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <MatzevaShow item={item} />
      {loading && <Loading isModalMode message={i18next.t('MATZEVA_SHOW:LOADING')} />}
    </LayoutContainer>
  );
};

export default MatzevaShowContainer;
